module.exports = __webpack_public_path__ + "img/photo-03.5fa99a7d.png";